import ResidentNcpPage from "./ResidentNcpPage";

export default ResidentNcpPage;
